'use client';

import { MarkViewContent, type MarkViewProps } from '@tiptap/react';
import { toWhitespaceCss } from './whitespace-utils';

export default function ZyCodeInlineMarkView({ mark }: MarkViewProps) {
    const preserveWhitespace = !!mark.attrs.preserveWhitespace;
    const allowWrap = !!mark.attrs.allowWrap;
    const whiteSpace = toWhitespaceCss(preserveWhitespace, allowWrap);

    return (
        <code style={whiteSpace ? { whiteSpace: whiteSpace as React.CSSProperties['whiteSpace'] } : undefined}>
            <MarkViewContent />
        </code>
    );
}
